
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $0fed3d1024e2cf6a$exports = {};
$0fed3d1024e2cf6a$exports = JSON.parse('[{"name":"2026 \uC5EC\uB984/\uAC00\uC744 \uB300\uD68C","href":"/competitions/2026"},{"name":"\uCD08\uB4F1\uBD80 \uB300\uD68C","href":"/competitions/jr"},{"name":"\uC911\xb7\uACE0\uB4F1\uBD80 \uB300\uD68C","href":"/competitions/sr"}]');


const $bd9e7a4b67634c00$var$$competitionsSubMenu = document.getElementById('competitions-sub-menu');
const $bd9e7a4b67634c00$var$competitionsSubMenuHtml = `
  <ul class="mx-auto mt-auto flex h-full max-w-7xl gap-6 overflow-x-auto px-4 text-sm sm:text-base lg:px-12">
    ${(0, (/*@__PURE__*/$parcel$interopDefault($0fed3d1024e2cf6a$exports))).filter((i)=>!i.hide).map((item)=>`
        <a
          href="${item.href}"
          class="cursor-pointer border-b-2 px-2 py-3 sm:py-4 font-normal text-nowrap transition ${window.location.pathname === item.href ? 'border-flamingo-500' : 'hover:border-flamingo-400 hover:text-zinc-500 border-transparent'}"
          >
          ${item.name}
        </a>
      `).join('')}
  </ul>
`;
if ($bd9e7a4b67634c00$var$$competitionsSubMenu) $bd9e7a4b67634c00$var$$competitionsSubMenu.innerHTML = $bd9e7a4b67634c00$var$competitionsSubMenuHtml;


//# sourceMappingURL=2026.8de44d7c.js.map
